export const WalletTransactionSkeletonMobile: {
  name: 'wallet_transaction_skeleton_mobile-68417542b08b'
} = {
  name: 'wallet_transaction_skeleton_mobile-68417542b08b'
}
